import { useEffect } from 'react';

const useMetaTags = ({ title, description, image, url, type = 'website' }) => {
  useEffect(() => {
    const upsertMetaBy = (attr, key, content) => {
      if (!content) return;
      let meta = document.querySelector(`meta[${attr}="${key}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, key);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Title
    if (title) document.title = title;

    // Open Graph
    upsertMetaBy('property', 'og:type', type);
    upsertMetaBy('property', 'og:title', title);
    upsertMetaBy('property', 'og:description', description);
    upsertMetaBy('property', 'og:image', image);
    upsertMetaBy('property', 'og:url', url);
    // Optional additional OG image fields for better previews
    upsertMetaBy('property', 'og:image:secure_url', image);

    // Twitter (Twitter prefers name="twitter:*")
    upsertMetaBy('name', 'twitter:card', 'summary_large_image');
    upsertMetaBy('name', 'twitter:title', title);
    upsertMetaBy('name', 'twitter:description', description);
    upsertMetaBy('name', 'twitter:image', image);

    // Standard meta description
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.setAttribute('name', 'description');
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
    }
  }, [title, description, image, url, type]);
};

export default useMetaTags;